import React from 'react';
import { Theme } from '@routific/hive';
import { observer } from 'mobx-react';
import DeletingCard from '../../shared/DeletingCard';
import { RouteDtoModelType } from '../../../store/mst/models';
import StandardRouteCard from './StandardRouteCard';
import { useStore } from '../../../store/mst';

const { Spacing } = Theme;

interface Props {
  route: RouteDtoModelType;
  stateless?: boolean;
  routeDetailsRef?: React.MutableRefObject<HTMLDivElement | null>;
  focusedCardRef?: React.MutableRefObject<HTMLDivElement | null>;
  selectable?: boolean;
  withTitle?: boolean;
  withColorBar?: boolean;
  withAssignDriver?: boolean;
  index?: number;
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>, uuid?: string, index?: number) => void;
  withStats?: boolean;
}

const RouteCard: React.FC<Props> = ({
  route, stateless, routeDetailsRef, selectable, withTitle = false, withColorBar = false, withAssignDriver, onClick, index, focusedCardRef, withStats = true,
}) => {
  const store = useStore();
  const getCardRef = (cardEvent: RouteDtoModelType) => {
    const isSelectedRoute = cardEvent.id === store.ui.selectedRoute?.id;
    return isSelectedRoute ? focusedCardRef : null;
  };

  return (route.isDeleting
    ? <DeletingCard style={{ height: 124, marginBottom: stateless ? 0 : Spacing.smSpacing }} />
    : (
      <div ref={getCardRef(route)}>
        <StandardRouteCard
          route={route}
          stateless={stateless || !withStats}
          routeDetailsRef={routeDetailsRef}
          selectable={selectable}
          withTitle={withTitle}
          withColorBar={withColorBar}
          withAssignDriver={withAssignDriver}
          index={index}
          onClick={withStats ? onClick : undefined}
          withStats={withStats}
        />
      </div>
    ));
};

export default observer(RouteCard);
